const FREE_PRIMARY_CTA_LABEL = 'Get it now';
const PAID_PRIMARY_CTA_LABEL = 'Start free trial';
const ADD_TO_SANDBOX_CTA_LABEL = 'Add to sandbox';
const CLOUD_MIGRATION_TRIAL_CTA_LABEL = 'Activate trial';
export const resolveInstallationCTALabel = _ref => {
  let {
    isFreeApp,
    isCloudMigrationTrialEligible,
    isEligibleForFreeOnSandbox
  } = _ref;
  if (isEligibleForFreeOnSandbox) {
    return ADD_TO_SANDBOX_CTA_LABEL;
  }
  if (isFreeApp) {
    return FREE_PRIMARY_CTA_LABEL;
  }
  if (isCloudMigrationTrialEligible) {
    return CLOUD_MIGRATION_TRIAL_CTA_LABEL;
  }
  return PAID_PRIMARY_CTA_LABEL;
};